// extracted by mini-css-extract-plugin
export default {"labels":"lsf-labels","labels_hidden":"lsf-labels_hidden","labels_inline":"lsf-labels_inline","waiting":"lsf-waiting"};